export default __webpack_public_path__ + "static/media/mozart1.a708a256.png";